import { useLocation, useParams } from 'react-router-dom';
import { ActivityListPage } from './ActivityListPage';
import { ActivityDetailPage } from './ActivityDetailPage';
import { ConnectDiscontinuedPage } from './ConnectDiscontinuedPage';
import { FrontierActivityCockpitEntry } from '../cockpit/FrontierActivityCockpitEntry';
import { SkillManagementPage } from './SkillManagementPage';
import { ProjectManagementPage } from './ProjectManagementPage';
import {
  ControlPlaneActivityCreationPage,
  FrontierActivityCreationPage,
} from '../activity-creation';

export const SpassuCodePage = () => {
  const location = useLocation();
  const params = useParams();

  // FlatRoutes consumes the full path, so we detect /skills via location
  if (location.pathname.endsWith('/skills')) {
    return <SkillManagementPage />;
  }

  // Project management: /spassu-code/project-members
  if (location.pathname.endsWith('/project-members')) {
    return <ProjectManagementPage />;
  }

  if (location.pathname.endsWith('/new/control-plane')) {
    return <ControlPlaneActivityCreationPage />;
  }

  if (location.pathname.endsWith('/new')) {
    return <FrontierActivityCreationPage />;
  }

  // A rota histórica permanece como entrada Frontier. A entry resolve a via
  // antes de montar qualquer client: Frontier renderiza seu cockpit e Control
  // Plane troca para a route ref do plugin dedicado.
  const metricsMatch = location.pathname.match(
    /\/spassu-code\/metrics\/([^/]+)\/?$/,
  );
  if (metricsMatch) {
    return <FrontierActivityCockpitEntry activityId={metricsMatch[1]} />;
  }

  // Ancorado no fim: `/connect/<id>/qualquer-coisa` NÃO é endereço de conexão.
  // Sem a âncora, o segmento extra era descartado em silêncio e a página abria
  // para o primeiro segmento — endereço malformado tratado como válido.
  const connectMatch = location.pathname.match(
    /\/spassu-code\/connect\/([^/]+)\/?$/,
  );
  if (connectMatch) {
    return <ConnectDiscontinuedPage activityId={connectMatch[1]} />;
  }

  const cliMatch = location.pathname.match(/\/spassu-code\/cli\/([^/]+)\/?$/);
  if (cliMatch) {
    return <ConnectDiscontinuedPage activityId={cliMatch[1]} />;
  }

  // If activityId param exists (from FlatRoutes /:activityId match), show detail
  const activityId = params.activityId ?? params['*'];
  if (activityId && activityId !== 'skills') {
    return <ActivityDetailPage />;
  }

  // Default: activity list
  return <ActivityListPage />;
};
